import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode } from '..';
import { parseTicketData } from './parseTicketData';
import { getConfiguration } from './utils/configuration';
import { dataFetchReducer } from './utils/dataFetchReducer';

export function useFetchCheckbetTicket(id, shouldExecute, pollingEnabled, skipExecution, loadNotificationData) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let intervalId = null;
        if (!shouldExecute) {
            clearInterval(intervalId);
            return;
        }
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const conf = getConfiguration();
        const url = conf['api']['getCheckbetTicket'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            idTicket: id,
            loadNotificationData
        };
        if (!skipExecution) {
            fetchData(url, params, function(response) {
                const data = !response ? null : parseTicketData(response);
                dispatch({ type: 'FETCH_SUCCESS', payload: data });
            });
        }

        let intervalMillis = null;
        try {
            intervalMillis = conf.ctp;
        } catch(e) {
            intervalMillis = 10000;
        }
        if (intervalMillis > 0) {
            if (pollingEnabled) {
                clearInterval(intervalId);
                intervalId = setInterval(() => {
                    fetchData(url, params, function(response) {
                        const data = parseTicketData(response);
                        dispatch({ type: 'FETCH_SUCCESS', payload: data });
                    });
                }, intervalMillis);
            } else if (intervalId != null) {
                clearInterval(intervalId);
            }
        }

        return () => {
            didCancel = true;
            clearInterval(intervalId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, shouldExecute, pollingEnabled]);

    return [state, dispatch];
}
